import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'widget-country-flag',
    templateUrl: './country-flag.component.html',
    styleUrls: ['./country-flag.component.scss'],
    standalone: false
})
export class CountryFlagComponent implements OnInit {

  @Input()
  countryCode:string; //ISO

  @Input()
  size:number=25;

  constructor() { }

  ngOnInit() {
  }

}
